import React from 'react';

const ContactHero = () => {
  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Book a Free <span className="text-blue-600">Strategy Session</span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Tell us briefly about your growth challenges and we can look at the upscaling opportunities over a 30min session.
            </p>
          </div>

          {/* Right Image - Oslo Opera House */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/dt1kqh4m_Oslo%20Opera%20House.jpeg"
                alt="Oslo Opera House"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;